<template>
    <div class="main">
        <!-- 头部 -->
        <navbar-header></navbar-header>

        <!-- 背景层 -->
        <div class="bg_box"></div>
        <title-bar :name="cateName"></title-bar>

        <!-- 新闻列表 -->
        <more-news-list-box @getname="getCateName"></more-news-list-box>

        <!-- 底部 -->
        <nav-footer></nav-footer>

    </div>
</template>

<script>
    import NavbarHeader from "../components/index/NavbarHeader"
    import MoreNewsListBox from "../components/news/MoreNewsListBox"
    import NavFooter from "../components/common/NavFooter"
    import TitleBar from "../components/common/TitleBar"
    export default {
        components: {
            NavbarHeader,
            MoreNewsListBox,
            NavFooter,
            TitleBar,
        },
        data() {
            return {
                cateName: ""
            }
        },
        methods: {
            getCateName( str ) {
                this.cateName = str
            }
        },
    }
</script>
<style lang="scss" scoped>
.main {
    position: relative;
    left: 0;
    top: 0;
    .bg_box {
        width: 100%;
        height: 746px;
        background: url("../assets/static/index/btm_bg.jpg") 0 0 no-repeat;
        background-size: 100% 100%;
        position: absolute;
        left: 0;
        top: 269px;
        z-index: -1;
    }
}

</style>